import(/* webpackMode: "eager" */ "/home/ubuntu/download/6963cce37683ed001403b6e2/almanara_moving/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6963cce37683ed001403b6e2/almanara_moving/src/app/about/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6963cce37683ed001403b6e2/almanara_moving/src/app/about/components/TeamSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6963cce37683ed001403b6e2/almanara_moving/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6963cce37683ed001403b6e2/almanara_moving/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6963cce37683ed001403b6e2/almanara_moving/src/components/ui/AppImage.tsx");
